import React from 'react';
import { COLORS } from '../../constants/styles';
export const WarningIconOld = ({ color = COLORS.error }: { color?: string }) => (
    <svg width="20" height="20" viewBox="1 1 22 22" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            d="M3.33105 19.5H20.6688L12.0003 4.17896L3.33105 19.5ZM22.3653 19.4535C22.7583 20.148 22.2431 21 21.4278 21H2.57205C1.7568 21 1.24155 20.148 1.63455 19.4535L11.0628 2.79C11.2661 2.43 11.6328 2.25 12.0003 2.25C12.3671 2.25 12.7338 2.43 12.9378 2.79L22.3653 19.4535Z"
            fill={color}
        />
        <path fillRule="evenodd" d="M11.25 14.25H12.75V7.5H11.25V14.25Z" fill={color} />
        <path
            fillRule="evenodd"
            d="M10.875 16.875C10.875 17.496 11.379 18 12 18C12.621 18 13.125 17.496 13.125 16.875C13.125 16.254 12.621 15.75 12 15.75C11.379 15.75 10.875 16.254 10.875 16.875Z"
            fill={color}
        />
    </svg>
);

export const WarningIcon = ({ size = '18', color = COLORS.error }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        preserveAspectRatio="xMinYMin slice"
        viewBox="0 0 32 32"
        focusable="false"
        height={size}
        width={size}
    >
        <path fill="none" d="M0 0h32v32H0z" />
        <path
            d="M29.82 25.94L17.25 3.72a1.45 1.45 0 0 0-2.5 0L2.18 25.94A1.4 1.4 0 0 0 3.43 28h25.14a1.4 1.4 0 0 0 1.25-2.06zM15 10h2v9h-2zm1 14a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 24z"
            fill={color}
        />
    </svg>
);
